var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e404"},[_c('img',{staticClass:"e404-img",attrs:{"src":require("@/assets/img/404.jpg"),"alt":""}}),_c('h2',{staticClass:"e404-title"},[_vm._v(" УПС... "),_c('br'),_vm._v(" Кажется вы заблудились ")])])
}]

export { render, staticRenderFns }